import _ from "lodash";
import sanitizeHtml from "sanitize-html";

function convertUrlToHttps(url: string) {
  // Check if the URL starts with http:// or https://
  if (url.startsWith("http://")) {
    return "https://" + url.slice(7);
  } else if (!url.startsWith("https://") && !url.startsWith("http://")) {
    // If the URL does not start with http:// or https://, prepend https://
    return "https://" + url;
  }
  return url;
}

const transformImage = (tagName: string, attribs: sanitizeHtml.Attributes) => {
  if (attribs.src) {
    attribs.src = convertUrlToHttps(attribs.src);
  }
  if (attribs.srcset) {
    attribs.srcset = attribs.srcset
      .split(",")
      .map((source) => {
        const [url, size] = source.trim().split(" ");
        if (!url) return "";
        return convertUrlToHttps(url) + (size ? " " + size : "");
      })
      .join(", ");
  }
  return { attribs, tagName };
};

// Custom transform function to convert <a> tags with localhost URLs to <p> tags
const transformLink = (tagName: string, attribs: sanitizeHtml.Attributes) => {
  if (tagName === "a" && attribs.href && attribs.href.includes("localhost")) {
    return {
      attribs: {},
      tagName: "p",
    };
  }
  if (attribs.href) {
    attribs.href = convertUrlToHttps(attribs.href);
  }

  return { attribs, tagName }; // Return the original tag to keep default behavior for other tags
};

/**
 * sanitizeHtmlInput is a function that sanitizes HTML input using the sanitize-html package.
 * @param input - The HTML input to sanitize.
 */
export function sanitizeHtmlInput(input: string | undefined) {
  if (!input) return "";

  const sanitizedHtml = sanitizeHtml(input, {
    allowedTags: [...sanitizeHtml.defaults.allowedTags, "img"],
    enforceHtmlBoundary: true,
    nonBooleanAttributes: _.without(sanitizeHtml.defaults.nonBooleanAttributes, "style"),
    transformTags: {
      a: transformLink,
      img: transformImage,
    },
  });

  return sanitizedHtml.replaceAll(" />", ">"); // Ensure self-closing tags are properly formatted
}
